var _mask, _path, _rect, _rect2, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 78,
    viewBox: "0 0 116 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2639_40233",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.761 17.8407C67.1654 10.7254 60.3783 5.29963 52.4257 2.38373C44.473 -0.532174 35.7873 -0.779709 27.6815 1.67855C19.5757 4.1368 12.4906 9.16719 7.49723 16.0092C2.50389 22.8513 -0.126167 31.133 0.00465154 39.6023C0.13547 48.0717 3.02006 56.2682 8.22232 62.9528C13.4246 69.6373 20.6617 74.4465 28.8395 76.6532C37.0174 78.86 45.6914 78.3443 53.5502 75.1842C61.4089 72.024 68.0253 66.3913 72.3989 59.1374L39 39L71.761 17.8407Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.761 17.8407C67.1654 10.7254 60.3783 5.29963 52.4257 2.38373C44.473 -0.532174 35.7873 -0.779709 27.6815 1.67855C19.5757 4.1368 12.4906 9.16719 7.49723 16.0092C2.50389 22.8513 -0.126167 31.133 0.00465154 39.6023C0.13547 48.0717 3.02006 56.2682 8.22232 62.9528C13.4246 69.6373 20.6617 74.4465 28.8395 76.6532C37.0174 78.86 45.6914 78.3443 53.5502 75.1842C61.4089 72.024 68.0253 66.3913 72.3989 59.1374L39 39L71.761 17.8407Z",
    stroke: "#D1E6FF",
    strokeWidth: 2,
    strokeDasharray: "6 6",
    mask: "url(#path-1-inside-1_2639_40233)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 38,
    width: 10,
    height: 60,
    rx: 5,
    transform: "rotate(-90 56 38)",
    fill: "#FFE60A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4805,
    y: 50.1426,
    width: 9.75,
    height: 50.1429,
    rx: 4.875,
    transform: "rotate(-90 42.4805 50.1426)",
    fill: "#D1E6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3203 25.0703C51.6279 25.0703 49.4453 22.8877 49.4453 20.1953C49.4453 17.5029 51.6279 15.3203 54.3203 15.3203L100.285 15.3203C102.977 15.3203 105.16 17.5029 105.16 20.1953C105.16 22.8877 102.977 25.0703 100.285 25.0703L54.3203 25.0703Z",
    fill: "#D1E6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1426 62.6777C47.4502 62.6777 45.2676 60.4951 45.2676 57.8027C45.2676 55.1103 47.4502 52.9277 50.1426 52.9277L96.1069 52.9277C98.7992 52.9277 100.982 55.1103 100.982 57.8027C100.982 60.4951 98.7993 62.6777 96.1069 62.6777L50.1426 62.6777Z",
    fill: "#F0F7FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.0011,
    cy: 39.0011,
    r: 32.8214,
    fill: "white",
    stroke: "#D1E6FF",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBg);
export default __webpack_public_path__ + "static/media/ic-bg.f2b22efc404861ab919fad032f286f7a.svg";
export { ForwardRef as ReactComponent };